export const ALLOWED_MONTHS_BACK_FOR_SCHEDULE_MANAGEMENT = 2;

export const ADMIN_SELF_SCHEDULE_EDIT_ERROR = "You cannot edit your own schedule";

export const GET_CURRENT_EMPLOYEE_MONTHLY_SCHEDULE_MAP_API = "getCurrentEmployeeMonthlyScheduleMap";
export const GET_EMPLOYEE_SCHEDULE_BY_DATE_RANGE_API = "getEmployeeScheduleByEidAndDateRange";
export const ADD_BASE_SCHEDULE_API = "addBaseSchedule";
export const GET_FREEDAY_STANDARD_RELIEF_MAP = "getFreedayStandardReliefMap"

export const CREATE_BASE_SCHEDULE_CONFIRMATION_MESSAGE = (employeeLastName, employeeFirstName, employeeId) => {
  return {
    __html: `Are you sure you want to create a Base Schedule for <b>${employeeLastName}, ${employeeFirstName} (${employeeId})</b>?`,
  };
};

export const BASE_SCHEDULE_OVERWRITE_WARNING_MESSAGE =
  "The new Base Schedule will overwrite any existing schedules in this Station for the selected dates. Approved trades and time off (both bid and ad-hoc) must be canceled manually and re-entered if still valid.";

export const SCHEDULE_UPDATE_TYPE = Object.freeze({
  CREATE: "CREATE",
  DELETE: "DELETE",
  UPDATE: "UPDATE",
});

export const FREEFORM_REASON_CHAR_LIMIT = 100;

export const employeeInfoErrorsInitialState = {
  startDateErrors: "",
  endDateErrors: "",
  commentErrors: "",
};

export const baseScheduleInitialState = {
  SUN: {
    start: { hr: "", min: "" },
    end: { hr: "", min: "" },
    position: "Float",
    assignment: "Float",
    isOff: false,
    isNA: false,
  },
  MON: {
    start: { hr: "", min: "" },
    end: { hr: "", min: "" },
    position: "Float",
    assignment: "Float",
    isOff: false,
    isNA: false,
  },
  TUE: {
    start: { hr: "", min: "" },
    end: { hr: "", min: "" },
    position: "Float",
    assignment: "Float",
    isOff: false,
    isNA: false,
  },
  WED: {
    start: { hr: "", min: "" },
    end: { hr: "", min: "" },
    position: "Float",
    assignment: "Float",
    isOff: false,
    isNA: false,
  },
  THU: {
    start: { hr: "", min: "" },
    end: { hr: "", min: "" },
    position: "Float",
    assignment: "Float",
    isOff: false,
    isNA: false,
  },
  FRI: {
    start: { hr: "", min: "" },
    end: { hr: "", min: "" },
    position: "Float",
    assignment: "Float",
    isOff: false,
    isNA: false,
  },
  SAT: {
    start: { hr: "", min: "" },
    end: { hr: "", min: "" },
    position: "Float",
    assignment: "Float",
    isOff: false,
    isNA: false,
  },
};

export const baseScheduleApplyToAllFilterInitialState = {
  start: { hr: "", min: "" },
  end: { hr: "", min: "" },
  position: "Float",
  assignment: "Float",
};

export const baseScheduleErrorsInitialState = {
  SUN: {
    error: "",
  },
  MON: {
    error: "",
  },
  TUE: {
    error: "",
  },
  WED: {
    error: "",
  },
  THU: {
    error: "",
  },
  FRI: {
    error: "",
  },
  SAT: {
    error: "",
  },
  fullScheduleError: "",
};
